import { CanActivateFn, Router } from "@angular/router";
import { inject } from "@angular/core";
import { OtpService } from "../services/otp.service";

export const processCheckoutGuard: CanActivateFn = () => {
    const router = inject(Router);
    const otpService = inject(OtpService);

    return otpService.isOtpSubmitted() || localStorage.getItem("otpSubmitted") === "true" 
        && otpService.getIsValidOtp() || localStorage.getItem("isValidOtp") === "true"
            ? true 
            : router.navigate(['/otp']);
}

export const otpGuard: CanActivateFn = () => {
    const router = inject(Router);
    const otpService = inject(OtpService);

    return otpService.isOtpGenerated() || localStorage.getItem("otpGenerated") === "true"
        ? true 
        : router.navigate(['/landing']);
}